define('views/content/reseller_managers',['require','views/base/list_page_view','views/components/reseller_manager/reseller_managers','collections/reseller_managers','text!templates/content/reseller_managers.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var ResellerManagersView = require('views/components/reseller_manager/reseller_managers');
    var ResellerManagersCollection = require('collections/reseller_managers');

    var temp = require("text!templates/content/reseller_managers.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'reseller-managers-page',
        titleKey: 'reseller_managers',

        setCollection: function () {
            this.collection = new ResellerManagersCollection();
        },

        onRender: function() {
            this.ListContainer.show(new ResellerManagersView({
                collection: this.collection
            }));
        }

    });
});
